import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import Section from '../components/common/Section';

const PartnersGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
`;

const PartnerCard = styled(motion.div)`
  background: white;
  border-radius: ${props => props.theme.borderRadius.medium};
  padding: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: ${props => props.theme.shadows.small};
  cursor: pointer;
`;

const PartnerLogo = styled.img`
  max-width: 100%;
  height: auto;
  filter: grayscale(100%);
  transition: filter 0.3s ease;

  &:hover {
    filter: grayscale(0);
  }
`;

const partners = [
  { id: 1, name: 'Microsoft', logo: '/images/partners/microsoft.png' },
  { id: 3, name: 'Amazon', logo: '/images/partners/amazon.png' },
  { id: 8, name: 'shopify', logo: '/images/partners/shopify.png' },
  { id: 9, name: 'tiktok', logo: '/images/partners/tiktok.png' },
];

const Partners = () => {
  const { t } = useTranslation();
  
  return (
    <div>
      <Section 
        title={t('partners.title')} 
        subtitle={t('partners.subtitle')}
      >
        <p>{t('partners.content')}</p>
        
        <PartnersGrid>
          {partners.map(partner => (
            <PartnerCard
              key={partner.id}
              whileHover={{ y: -5 }}
              transition={{ type: 'spring', stiffness: 300 }}
            >
              <PartnerLogo 
                src={partner.logo} 
                alt={partner.name}
              />
            </PartnerCard>
          ))}
        </PartnersGrid>
      </Section>
    </div>
  );
};

export default Partners;